import React from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
import { useWorkspaceTabs } from '../../hooks/useWorkspaceTabs';

const WorkspaceTabBar = () => {
  const { allTabs, openTabs, closeTab, isTabActive, navigateToTab } = useWorkspaceTabs();

  const visibleTabs = Array.from(openTabs).filter((tabKey) => allTabs[tabKey]);

  if (visibleTabs.length === 0) return null;

  return (
    <div
      className="workspace-tab-bar shrink-0"
      aria-label="Workspace tabs"
    >
      <div className="flex items-stretch overflow-x-auto [scrollbar-width:thin]">
        {visibleTabs.map((tabKey) => {
          const tab = allTabs[tabKey];
          if (!tab) return null;

          const Icon = tab.icon;
          const active = isTabActive(tabKey);

          return (
            <div
              key={tabKey}
              className={cn(
                'workspace-tab group',
                active ? 'workspace-tab--active' : 'workspace-tab--inactive'
              )}
            >
              <button
                type="button"
                onClick={() => navigateToTab(tabKey)}
                className="workspace-tab__label-btn"
              >
                <Icon className="workspace-tab__icon" aria-hidden />
                <span className="truncate">{tab.label}</span>
              </button>
              {openTabs.size > 1 && (
                <button
                  type="button"
                  onClick={(e) => closeTab(tabKey, e)}
                  className="workspace-tab__close"
                  title="Close tab"
                  aria-label={`Close ${tab.label}`}
                >
                  <X className="h-3.5 w-3.5" strokeWidth={2} />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WorkspaceTabBar;
